/**
 * There are two fixes on this picker regarding Safari/Firefox first day of daylight saving time: on Chrome/IE/Edge/Opera/etc if we create a midnight datetime on the first day of daylight saving, it overlaps to 1 AM on that same first day. On Safari/Firefox, it goes back to 23 PM of the previous day. More details here: https://github.com/angular-ui/bootstrap/issues/6291
 * First fix: always set the datepicker model to 1 AM at least (never midnight). If we don't do that, the picker duplicates the day before the first day of the daylight saving time
 * Second fix: fix the newly created datetimes on 23 PM of the previous day to 1 AM of the next (correct) day
 */
angular.module('utils').directive('tgDatePicker', function (tgClock) {
	return {
		restrict: 'E',
		templateUrl: function (element, attrs) {
			if (!attrs.templateType || attrs.templateType == 'complete') {
				return '/app/components/utils/tg-date-picker'
			} else if (attrs.templateType == 'simple') {
				return '/app/components/utils/tg-date-picker-simple'
			}
		},
		require: 'ngModel',
		scope: {
			ngRequired: '=',
			ngDisabled: '=',
			datePickerOptions: '=',
			hideDate: '=',
			lazyRendering: '=',
			templateType: '@',
			lang: '@',
		},
		replace: true,
		controller: [
			'$scope',
			function ($scope) {
				$scope.datePickerModel = null

				if (!$scope.datePickerOptions) {
					$scope.datePickerOptions = {
						showWeeks: false,
						minDate: moment.utc(moment().format('YYYY-MM-DD')).add(1, 'hours').toDate(), //Safari/Firefox fix
					}
				}
			},
		],
		link: function (scope, element, attrs, ngModelCtrl, transcludeFn) {
			if (scope.lazyRendering) {
				scope.display = false
			} else {
				scope.display = true
			}

			switch (scope.lang) {
				case 'en':
					moment.locale('en')
					break
				default:
					scope.lang = 'pt'
					moment.locale('pt-br')
					break
			}

			//Generates an unique id for accessibility purposes
			scope.buttonId = new Date().valueOf() + '_button'

			//To store the ul element, the date text toggle button and the calendar icon
			var ul, dateTextBtn, calendarIcon
			if (!scope.templateType || scope.templateType == 'complete') {
				ul = angular.element(element[0].firstElementChild.lastElementChild)
				dateTextBtn = angular.element(element[0].firstElementChild.childNodes[3])
				calendarIcon = angular.element(element[0].firstElementChild.firstElementChild.firstElementChild)

				//Avoids the dropdown from opening when the user clicks on the calendar icon
				calendarIcon.on('click', function (e) {
					e.stopPropagation()
				})
			} else if (scope.templateType == 'simple') {
				ul = angular.element(element[0].lastElementChild)
				dateTextBtn = angular.element(element[0].firstElementChild)
			}

			//Avoids the dropdown from closing when the user clicks inside the datepicker to navigate through the months
			ul.on('click', function (e) {
				e.stopPropagation()
			})

			dateTextBtn.on('click', function (e) {
				if (!scope.display) {
					scope.display = true
					ul.focus()
				}
			})

			scope.dropdownToggle = function () {
				dateTextBtn.dropdown('toggle')
			}

			function fixDaylightSavingTimeFirstDay(momentDate) {
				if (!momentDate) return
				if (momentDate.hour() === 23) momentDate.add(1, 'days').hour(1)
				return momentDate
			}

			scope.onChange = function () {
				var dbDate = moment.tz(moment.utc(scope.datePickerModel).format('YYYY-MM-DD'), tgClock.dbDateTz)
				ngModelCtrl.$setViewValue(fixDaylightSavingTimeFirstDay(dbDate).toDate())
				//Closes the dropdown when the user selects a date
				scope.dropdownToggle()

				// var dbDate = moment.tz(moment.utc(scope.datePickerModel).format('YYYY-MM-DD'), tgClock.dbDateTz);
				// if(dbDate.hour() == 23) dbDate.add(1, 'days').hour(1); //Safari/Firefox fix
				// ngModelCtrl.$setViewValue(dbDate.toDate());
				// //Closes the dropdown when the user selects a date
				// scope.dropdownToggle();
			}

			/**
			 * The code below is to make the calendar button clickable if needed.
			 * This was removed because the other dropdowns do not show this behavior.
			 */
			// //Toggles the dropdown when the user clicks on the calendar icon
			// calendarIcon.on('click', function (e) {
			//     e.stopPropagation(); //This is necessary!
			//     scope.dropdownToggle();
			// });

			//Intercepts any model init by code and inits the datePickerModel as well
			ngModelCtrl.$formatters.push(function (value) {
				if (value) {
					var dbDateTime = moment.tz(value, tgClock.dbDateTz)
					scope.datePickerModel = moment
						.utc(fixDaylightSavingTimeFirstDay(dbDateTime).format('YYYY-MM-DD'))
						.add(1, 'hours')
						.toDate() //Safari/Firefox fix

					// var dbDateTime = moment.tz(value, tgClock.dbDateTz);
					// if(dbDateTime.hour() == 23) dbDateTime.add(1, 'days'); //Safari/Firefox fix
					// scope.datePickerModel = moment.utc(dbDateTime.format('YYYY-MM-DD')).add(1, 'hours').toDate(); //Safari/Firefox fix
				} else {
					scope.datePickerModel = null
				}

				return value
			})

			scope.getDayOfWeekText = function () {
				if (scope.hideDate) {
					return '--'
				}

				if (!ngModelCtrl.$modelValue) {
					return 'Qual a data do aniversário?'
				}

				return fixDaylightSavingTimeFirstDay(moment.tz(ngModelCtrl.$modelValue, tgClock.dbDateTz)).format(
					'dddd'
				)
			}

			scope.getDayOfYearText = function () {
				if (!ngModelCtrl.$modelValue || scope.hideDate) {
					return ''
				}

				var date = fixDaylightSavingTimeFirstDay(moment.tz(ngModelCtrl.$modelValue, tgClock.dbDateTz))

				switch (scope.lang) {
					case 'en':
						return date.format('MMMM') + ' ' + date.format('Do')
					default:
						return date.format('DD') + ' de ' + date.format('MMMM')
				}
			}

			scope.getSimpleDayOfYearText = function () {
				if (scope.hideDate) {
					return '--'
				}

				if (!ngModelCtrl.$modelValue) {
					return 'Selecione'
				}

				var date = fixDaylightSavingTimeFirstDay(moment.tz(ngModelCtrl.$modelValue, tgClock.dbDateTz))
				return date.format('DD-MM-YYYY')
			}

			scope.getPlaceholderClassObj = function () {
				return { placeholder: !ngModelCtrl.$modelValue && !scope.hideDate }
			}
		},
	}
})
